var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('pui-chip',{staticClass:"status-chip",attrs:{"backgroundColor":_vm.color,"title":_vm.piivoTranslate(_vm.value)}},[_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm._f("piivoTranslate")(_vm.value)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }